import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatFormField, MatHint } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { Subscription } from 'rxjs';

import { CommonService } from '@shared/services/common.service';
import { MetadataService, MetadataSlugs } from '@shared/services/metadata.service';

@Component({
    selector: 'app-login-notice',
    templateUrl: './login-notice.component.html',
    styleUrls: ['./login-notice.component.scss'],
    standalone: true,
    imports: [MatFormField, MatInput, ReactiveFormsModule, FormsModule, MatHint, MatButton]
})
export class LoginNoticeComponent implements OnInit, OnDestroy {
  protected noticeContent: string | null = null;
  private _sub: Subscription | undefined;

  constructor(
    private _metadataService: MetadataService,
    private _commonService: CommonService
  ) {}

  ngOnInit(): void {
    this.getContent();
  }

  getContent() {
    this._metadataService.get<string>(MetadataSlugs.LoginNotice).subscribe({
      next: metadata => {
        this.noticeContent = metadata.value;
      },
      error: () => {
        this.noticeContent = '';
      },
    });
  }

  save() {
    this._sub = this._metadataService.set(MetadataSlugs.LoginNotice, this.noticeContent).subscribe({
      next: () => {
        this._commonService.openSuccessSnackBar('Notice saved successfully!');
      },
      error: () => {
        this._commonService.openErrorSnackBar('Error occurred while saving notice');
      },
    });
  }

  ngOnDestroy(): void {
    this._sub?.unsubscribe();
  }
}
